import React from 'react';
import PropTypes from 'prop-types';
import './PageWrapper.css';

const PageWrapper = ({ children, isMenuOpen = false }) => {
  const menuOpen = typeof isMenuOpen === 'string' ? isMenuOpen === 'true' : !!isMenuOpen;

  return (
    <div className={`page-wrapper ${menuOpen ? 'menu-open' : ''}`}>
      {children}
    </div>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isMenuOpen: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ])
};

export default PageWrapper; 